



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'HeadersTable',
})
export default class extends Vue {
    @Prop({ required: true }) headers!: { [k: string]: string };

    get sortedKeys(): string[] {
        if (!this.headers) return [];
        return Object.keys(this.headers).sort((a, b) =>
            a.toLowerCase().localeCompare(b.toLowerCase()),
        );
    }
}
